const STORAGE_KEY = "dv-ui-theme";

export type UiTheme = "clinical" | "classic";

export const THEME_OPTIONS: Array<{ id: UiTheme; label: string; hint: string }> = [
  {
    id: "clinical",
    label: "Светлая",
    hint: "Клиническое оформление",
  },
  {
    id: "classic",
    label: "Тёмная",
    hint: "Классический Limitless",
  },
];

type ThemeListener = (theme: UiTheme) => void;

const listeners = new Set<ThemeListener>();

export const getStoredTheme = (): UiTheme => {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === "classic" || value === "clinical") return value;
  } catch {
    /* ignore */
  }
  return "clinical";
};

export const applyTheme = (theme: UiTheme) => {
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.classList.toggle("theme-classic", theme === "classic");
  root.classList.toggle("theme-clinical", theme === "clinical");
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
  listeners.forEach((listener) => listener(theme));
};

export const onThemeChange = (listener: ThemeListener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const initTheme = () => {
  applyTheme(getStoredTheme());
};
